module.exports = __webpack_public_path__ + "assets/img/logo-biz-gray.ecd917a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-biz-gray.png
// module id = 824
// module chunks = 1